import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=6c10dc69"
import script from "./Duplicates.vue?vue&type=script&lang=js"
export * from "./Duplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports